/**
 * @component CollegesTableActions
 * @description
 * Botón de acción para abrir el modal de creación de un nuevo colegio.
 * Se renderiza dentro del encabezado de la tabla de colegios.
 *
 * @param {Function} handleOpen - Función que se ejecuta al hacer clic en el botón "Nuevo".
 *
 * @example
 * <CollegesTableActions handleOpen={handleOpenModal} />
 */

import React from 'react';
import IconButton from 'components/common/IconButton';

const CollegesTableActions = ({ handleOpen }) => {
	/**
	 * Llama a la función externa para abrir el modal de nuevo registro.
	 */
	const handleNew = () => {
		handleOpen();
	};

	return (
		<div id="orders-actions">
			<IconButton
				variant="falcon-default"
				size="sm"
				icon="plus"
				transform="shrink-3"
				iconAlign="middle"
				onClick={handleNew}>
				<span className="d-none d-sm-inline-block d-xl-none d-xxl-inline-block ms-1">
					Nuevo
				</span>
			</IconButton>
		</div>
	);
};

export default CollegesTableActions;